export default __webpack_public_path__ + "7c90a1f7d46d16f5cfc8667dd99cc3b8.jpg";